'use strict';
var titleWithFlight = '';
var oldTitle = '';
var fistExecution = true;
var tabCatcherWorker;
var tabCatcherBlob;
var locale = 'en-US';
var searchData = null;
var $window = $(window);
var $body = $('body');
var blurFunction;
var focusFunction;
var trackingUtils = require('./tracking.utils');
var notificationService = require('./notifications').notificationService();
const logger = require('od-modules/utils/logger');

var createBlob = function() {
    var response = 'self.onmessage = ' + manageTime.toString();
    if (Odigeo._.isUndefined(tabCatcherBlob)) {
        try {
            tabCatcherBlob = new Blob([response], {type: 'application/javascript'});
        } catch (error) {
            logger.error(error);
            var myTabCatcherBlob;
            var BlobBuilder;
            window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
            BlobBuilder = window.BlobBuilder;
            myTabCatcherBlob = new BlobBuilder();
            myTabCatcherBlob.append(response);
            tabCatcherBlob = myTabCatcherBlob.getBlob();
        }
    }
};

var setSearchData = function() {
    searchData = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
};

var generateTitleWithFlight = function() {
    if (!Odigeo._.isNull(searchData) && !!searchData.searchSegments.length) {
        titleWithFlight = '';
        Odigeo._.each(searchData.searchSegments, function(segment, index) {
            titleWithFlight = titleWithFlight + (index > 0 ? ' | ' : '') +
                segment.departure.city + ' -> ' + segment.destination.city +
                ' (' + new Date(segment.dateStr).toLocaleDateString(locale) + ')';
        }, this);
    }
};

var onClickNotification = function() {
    window.focus();
    trackingUtils.trackEvent('browser_notification', 'browser_notification_clicked');
    this.close();
};

var sendBrowserNotification = Odigeo._.once(function(page) {
    if (page === 'flights_pax_page' || page === 'flights_pay_page') {
        var notificationText = page === 'flights_pax_page' ? Odigeo.UIElements.translations.notifications.paxGeneralBody :
            Odigeo.UIElements.translations.notifications.payGeneralBody;
        var notificationSubtitleText = page === 'flights_pax_page' ? Odigeo.UIElements.translations.notifications.paxSubtitleBody :
            Odigeo.UIElements.translations.notifications.paySubtitleBody;
        notificationService.send(notificationText, {body: notificationSubtitleText}, onClickNotification).then(function() {
            trackingUtils.trackEvent('browser_notification', 'browser_notification_loaded');
        });
    }
});

var changeTabTitle = function(page) {
    if (Odigeo._.isUndefined(tabCatcherWorker)) {
        oldTitle = document.title;
        createBlob();
        tabCatcherWorker = new Worker(URL.createObjectURL(tabCatcherBlob));
        tabCatcherWorker.onmessage = function(e) {
            document.title = e.data;
            if (fistExecution) {
                changeFavicon(true);
                fistExecution = false;
                sendBrowserNotification(page);
            }
        };
    }
    tabCatcherWorker.postMessage(titleWithFlight);
};

var inEDTabFocus = function() {
    if (!Odigeo._.isUndefined(tabCatcherWorker)) {
        document.title = oldTitle;
        tabCatcherWorker.terminate();
        tabCatcherWorker = undefined;
        changeFavicon(false);
    }
};

var changeFavicon = function(changeToNew) {
    var favicons = $('link[rel*="icon"]');
    var oldIcon = changeToNew ? 'favicon.ico' : 'favicon_2.ico';
    var newIcon = changeToNew ? 'favicon_2.ico' : 'favicon.ico';
    Odigeo._.each(favicons, function(link) {
        link.href = link.href.replace(oldIcon, newIcon);
    });
};

var manageTime = function(e) {
    var fullTitle = e.data;
    var title = fullTitle;
    var bounceInterval;
    var timeToStart = 17000;
    var timePaused = 3000;
    var timeToMove = 200;
    var bounceTitle = function() {
        var titleToShow = (title.length > 1) ? title.substring(1, title.length) : fullTitle;
        postMessage(titleToShow);
        if (title.length > 1) {
            title = titleToShow;
        } else {
            relaunchBounce();
        }
    };

    var relaunchBounce = function() {
        clearInterval(bounceInterval);
        title = fullTitle;
        setTimeout(changeTitle, timePaused);
    };

    var changeTitle = function() {
        postMessage(fullTitle);
        bounceInterval = setInterval(bounceTitle, timeToMove);
    };
    setTimeout(relaunchBounce, timeToStart);
};
var startWithParameters = function(webLocale) {
    fistExecution = true;
    locale = webLocale.replace('_', '-');
};

var tabChanged = function(webLocale, page) {
    startWithParameters(webLocale, page);
    setSearchData();
    if (!Odigeo._.isNull(searchData)) {
        generateTitleWithFlight();
        changeTabTitle(page);
    }
};

var inEDTab = function() {
    if (!Odigeo._.isNull(searchData)) {
        inEDTabFocus();
    }
};

var initEvents = function(page) {
    if (Odigeo._.isFunction(blurFunction) && Odigeo._.isFunction(focusFunction)) {
        $window.off(Odigeo.Events.blur, blurFunction)
            .off(Odigeo.Events.focus, focusFunction);
    }

    blurFunction = Odigeo._.partial(tabChanged, $body.data('locale'), page);
    focusFunction = Odigeo._.partial(inEDTab, page);

    $window.on(Odigeo.Events.blur, blurFunction)
        .on(Odigeo.Events.focus, focusFunction);
};

module.exports = {
    init: function(page) {
        if (Odigeo.SessionScope.isMeta) {
            initEvents(page);
        }
    },
};
